import React from 'react';
import OperationsApp from './commerce/OperationsApp';
export default function SellerApp(){return <OperationsApp mode="seller"/>;}
